import { apiGet } from "../utils/api"

export default function Test(){
    const connectTwitter = () => {
        apiGet('auth/x/').then(res => {
            const { auth_url, code_verifier } = res
            localStorage.setItem('twitter_code_verifier', code_verifier)
            window.location.href = auth_url
        })
    }
  return(
    <button className="py-52 self-center" onClick={connectTwitter}>initiate x call</button>
  )
}